import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ControlInformation from './components/ControlInformation';

const Control = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Controle</h3>
      </Col>
    </Row>
    <Row>
      <ControlInformation />
    </Row>
  </Container>
);

export default Control;
